import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideNgxStripe } from 'ngx-stripe';
import { routes } from './app.routes';
import { environment } from '../environments/environment';

/**
 * Modern Angular application configuration
 * Uses standalone components and function-based providers
 */
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),

    provideRouter(
      routes,
      withComponentInputBinding(),
      withViewTransitions()
    ),

    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi()
    ),

    provideAnimations(),

    provideNgxStripe(environment.stripePublishableKey),
  ],
};
